export const Types = {
    GET_POOL_BY_ID: "GET_POOL_BY_ID",
    SET_POOL_BY_ID: "SET_POOL_BY_ID",
    GET_AREA_FOR_POOL: "GET_AREA_FOR_POOL",
    SET_AREA_FOR_POOL: "SET_AREA_FOR_POOL",
    GET_MAINTENANCE_TYPE_LIST: "GET_MAINTENANCE_TYPE_LIST",
    SET_MAINTENANCE_TYPE_LIST: "SET_MAINTENANCE_TYPE_LIST",
    GET_BREAK_DOWN_REASON_GROUP_LIST_FOR_POOL: "GET_BREAK_DOWN_REASON_GROUP_LIST_FOR_POOL",
    SET_BREAK_DOWN_REASON_GROUP_LIST_FOR_POOL: "SET_BREAK_DOWN_REASON_GROUP_LIST_FOR_POOL",
    GET_POOL_RELATION_BY_ID: "GET_POOL_RELATION_BY_ID",
    SET_POOL_RELATION_BY_ID: "SET_POOL_RELATION_BY_ID",
    EDIT_POOL_RELATION: "EDIT_POOL_RELATION",
    EDIT_POOL_RELATION_RES: "EDIT_POOL_RELATION_RES",
    RESET_BREAK_DOWN_REASON_GROUPS: "RESET_BREAK_DOWN_REASON_GROUPS",
    RESET_EDIT_POOL_RELATION_RES: "RESET_EDIT_POOL_RELATION_RES",
    GET_BREAKDOWN_REASON_PLACE_DATA: "GET_BREAKDOWN_REASON_PLACE_DATA",
    SET_BREAKDOWN_REASON_PLACE_DATA: "SET_BREAKDOWN_REASON_PLACE_DATA",
};

export const getPoolById = (payload) => ({
    type: Types.GET_POOL_BY_ID,
    payload: payload,
});
export const setPoolById = (payload) => ({
    type: Types.SET_POOL_BY_ID,
    payload: payload,
});
export const getAreaList = () => ({
    type: Types.GET_AREA_FOR_POOL,
});
export const setAreaList = (payload) => ({
    type: Types.SET_AREA_FOR_POOL,
    payload: payload,
});
export const getMaintenanceTypeList = () => ({
    type: Types.GET_MAINTENANCE_TYPE_LIST,
});
export const setMaintenanceTypeList = (payload) => ({
    type: Types.SET_MAINTENANCE_TYPE_LIST,
    payload: payload,
});
export const getBreakDownReasonGroupList = () => ({
    type: Types.GET_BREAK_DOWN_REASON_GROUP_LIST_FOR_POOL,
});
export const setBreakDownReasonGroupList = (payload) => ({
    type: Types.SET_BREAK_DOWN_REASON_GROUP_LIST_FOR_POOL,
    payload: payload,
});
export const getPoolRelationById = (payload) => ({
    type: Types.GET_POOL_RELATION_BY_ID,
    payload: payload,
});
export const setPoolRelationById = (payload) => ({
    type: Types.SET_POOL_RELATION_BY_ID,
    payload: payload,
});
export const editPoolRelation = (payload) => ({
    type: Types.EDIT_POOL_RELATION,
    payload: payload,
});
export const setEditPoolRelationResponse = (payload) => ({
    type: Types.EDIT_POOL_RELATION_RES,
    payload: payload,
});
export const resetBreakDownReasonGroups = () => ({
    type: Types.RESET_BREAK_DOWN_REASON_GROUPS,
});
export const resetEditPoolRelation = () => ({
    type: Types.RESET_EDIT_POOL_RELATION_RES,
});
export const getBreakdownReasonPlaceData = () => ({
    type: Types.GET_BREAKDOWN_REASON_PLACE_DATA,
});
export const setBreakdownReasonPlaceData = (payload) => ({
    type: Types.SET_BREAKDOWN_REASON_PLACE_DATA,
    payload,
});
